var React = require('react');

function Expand (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.29145 8.08368L12 13.8122L17.7086 8.08368C17.8197 7.97211 18 7.97211 18.1112 8.08368L18.9166 8.8919C19.0278 9.00347 19.0278 9.18438 18.9166 9.29595L12.4027 15.8326C12.1803 16.0558 11.8197 16.0558 11.5973 15.8326L5.08339 9.29595C4.9722 9.18438 4.9722 9.00347 5.08339 8.8919L5.8888 8.08368C5.99999 7.97211 6.18026 7.97211 6.29145 8.08368Z","fill":"#333333"}));
}

Expand.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Expand;

Expand.default = Expand;
